const state = {
    navigatorInfo:{},
    partyBuildInfo:{},
    infoRules:{},
    infoYearsReport:{},
    currentTap:''
};
const getters = {
    getNavigatorInfo(state){
      return state.navigatorInfo;
    },
    getCurrentTap(state){
      return state.currentTap;
    }
    
};
const mutations = {
    setNavigatorInfo(state,obj){
      state.navigatorInfo = obj;
    },
    setCurrentTap(state,obj){
      state.currentTap = obj;
    }
};
const actions = {
    ActionSetNavigator:(context,obj) => {
      context.commit("setNavigatorInfo", obj);
    },
    ActionSetCurrentTap:(context,obj) => {
      context.commit("setCurrentTap", obj);
    },
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
